const text = {
  darkest: '#000000',
  dark: '#393c59',
  mid: '#696969',
  light: '#898989',
  lightest: '#DDDDDD',
  error: '#EB4525',
  success: '#B7DE6A'
}

const backgrounds = {
  darker: '#484848',
  dark: '#28a4dd',
  mid: '#DDDDDD',
  light: '#F5F5F5',
  warning: '#EB4525BB'
}

const growSmartColors = {
  primary: {
    dark: '#23575d',
    base: '#9ed5db',
    light: '#a2d7dc',
    lightest: '#c7e7ea'
  },
  secondary: {
    dark: '5ab7d4',
    base: '#5ab7d4',
    light: '#9ad3e5',
    lightest: '#c2e5ef'
  },
  borders: {
    default: '#DDDDDD',
    dark: '#484848',
    medium: '#898989',
    error: '#EB4525',
    success: '#B7DE6A',
    required: '#ED9920'
  }
}

const colorScheme = growSmartColors
const { primary, secondary, borders } = colorScheme

export { text, backgrounds, primary, secondary, borders }
